export enum EDemoCommand
{
    ResizeDemo = 1,
}